module.exports = __webpack_public_path__ + "assets/b70b06b7854c645e089976b012866fab.png";